export default __webpack_public_path__ + "static/media/youtube.982ec5ce.gif";